<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                轮播管理
               
            </div>
            
            <div >

                <!-- table组件 -->
                <div class="my_table">
                    <!-- <Header class="my_title txt_l">
                        <span class='my_titleL'>
                            <Icon class="fw_900 " type="ios-list" size='30'/>     
                            筛选查询
                        </span>
                    </Header> -->
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">                             
                            <Button class="mR5"    type="info"    @click="route='/layout/circle/banner/add';addFun()" > <Icon type="md-add" />添加</Button>                              
                            </div>
                            
                        </Row>
                     
                    </div>
                
                
                </div>
                <!-- table组件 -->
                <div class="my_table  ">
                    <Header class="my_title txt_l">
                        <span class="my_titleL">
                        <Icon class="fw_900 " type="ios-list" size='30'/>     
                            数据列表 
                        </span>
                        
                        <div class="ct_rgt">
                            
                            <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                            
                        </div>
                    </Header>
                    <Table     border :columns="columns1" :data="data1" ref='table'>
                    
                        <!-- 图片 -->
                        <template slot-scope="{ row }" slot="image" >
                            <div class="img_c">
                                <img v-if="row.image" :src="row.image"  alt="">
                            </div>
                                                    
                        </template>
                        <!-- 展示类型 -->
                        <template slot-scope="{ row }" slot="type" >
                            <span v-if="row.type == 0">动态</span>                   
                            <span v-if="row.type == 1">商城</span>                   
                        </template>
                        
                        
                        <!-- 按钮 -->
                        <template slot-scope="{ row, index }" slot="btn">
                            <!-- <Poptip trigger="hover" :title="row.surname" content="查看"> -->
                            
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click="route='/layout/circle/banner/editor';editorFun(row)"  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click="route='/layout/circle/banner/del';delFun(row)"  type="error"      icon="md-close"></Button>
                            </Poptip>
                        
                        </template>
                        
                    </Table>
                
                    
                    <!-- 编辑轮播 -->
                    <Modal
                        v-model="modal1"
                        title="轮播编辑"
                        @on-ok="ok1"
                        @on-cancel="cancel1"
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel1'>取消</Button>
                            <Button type='primary' size='large' @click='ok1'>修改</Button>
                        </div>
                        <ul class="list_ul">
                            <!-- 跳转类型-->
                             <li>
                                <div class='list_title'> <span class="cRed">*</span> 跳转类型 :</div> 
                                <div class="list_con">
                                    <Select class="select "  v-model="model1">
                                        <Option  v-for="item in type" :value="item.code" :key="item.code">{{ item.name }}</Option>
                                    </Select>
                                </div>                                            
                            </li>
                             <!-- 轮播标题-->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 轮播标题 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入轮播标题"    />
                                </div>                                            
                            </li>          
                                 
                            
                            <!-- 轮播描述-->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 轮播描述 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model3"   type='text' class="ipt"  placeholder="请输入轮播描述"    />
                                </div>                                            
                            </li>      
                            <!-- 当前图片-->
                            <li>
                                <div class='list_title'>  当前图片 :</div> 
                                <div class="list_con imgS" >
                                    <img  :src="ed_img" v-if='ed_img' alt="">
                                    <img  src="../../../../public/images/head_01.png"  v-if='!ed_img'  alt="">
                                    
                                </div>                                            
                            </li>                                             
                                                            
                            <!-- 轮播图片 model5 -->
                            <li>
                                <div class='list_title'><span class="cRed">*</span>  图片 :</div> 
                                <div class="list_con" >
                                    <cropper @childFun="childFun2"   :data="cropper_data"  ></cropper>

                                </div>                                            
                            </li>  
                                                              
                            <!-- 排序 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input      type='number' class="ipt"  placeholder="请输入排序" v-model="model6"   />
                                </div>                                            
                            </li> 
                            <!-- 展示类型 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 展示类型 :</div> 
                                <div class="list_con">
                                    <Select class="select "  v-model="model9">
                                        <Option  v-for="item in type2" :value="item.code" :key="item.code">{{ item.name }}</Option>
                                    </Select>
                                </div>                                            
                            </li> 
                            <!-- 跳转ID-->
                            <li>
                                <div class='list_title'>  跳转ID :</div> 
                                <div class="list_con">
                                    <Input   v-model="model4"   type='text' class="ipt"  placeholder="请输入跳转ID"   />
                                </div>                                            
                            </li>                
                            <!-- 跳转路径 -->
                            <li>
                                <div class='list_title'>  跳转路径 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model7"    type='text' class="ipt"  placeholder="请输入跳转路径"    />
                                </div>                                            
                            </li>    

                                                              
                            <!-- 图片状态 -->
                            <li>
                                <div class='list_title'>  图片状态 :</div> 
                                <div class="list_con">
                                    <i-switch class='mSwitch' v-model="model8" true-value="0" false-value="1" @on-change="change_btn" />
                                </div>                                            
                            </li>                                          

                        </ul>                            
                       
                    </Modal>
                    <!-- 确认删除框 -->
                    <Modal
                        v-model="delM"
                        title="提示"
                        @on-ok="delOk"
                        class-name="vertical-center-modal"
                        >
                        <p>确定删除吗?</p>
                        
                    </Modal>


                    <!-- 用户组添加弹窗 -->
                    <Modal
                        v-model="modal2"
                        title="轮播添加"
                    
                        class-name="vertical-center-modal"
                    >
                        <div slot="footer">
                            <Button type='text' size='large' @click='cancel_add'>取消</Button>
                            <Button type='primary' size='large' @click='ok_add'>添加</Button>
                        </div>
                        <ul class="list_ul">
                        
                            <!-- 跳转类型-->
                             <li>
                                <div class='list_title'> <span class="cRed">*</span> 跳转类型 :</div> 
                                <div class="list_con">
                                    <Select class="select "  v-model="model1">
                                        <Option  v-for="item in type" :value="item.code" :key="item.code">{{ item.name }}</Option>
                                    </Select>
                                </div>                                            
                            </li>
                             <!-- 轮播标题-->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 轮播标题 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model2"   type='text' class="ipt"  placeholder="请输入轮播标题"    />
                                </div>                                            
                            </li>          
                                 
                            
                            <!-- 轮播描述-->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 轮播描述 :</div> 
                                <div class="list_con">
                                    <Input   v-model="model3"   type='text' class="ipt"  placeholder="请输入轮播描述"    />
                                </div>                                            
                            </li>      
                                                                 
                                                            
                            <!-- 轮播图片 model5 -->
                            <li>
                                <div class='list_title'><span class="cRed">*</span>  图片 :</div> 
                                <div class="list_con">
                                   <cropper @childFun="childFun2"   :data="cropper_data1"  ></cropper> 
                                </div>                                            
                            </li>  
                                                              
                            <!-- 排序 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 排序 :</div> 
                                <div class="list_con">
                                    <Input      type='number' class="ipt"  placeholder="请输入排序" v-model="model6"   />
                                </div>                                            
                            </li> 
                            <!-- 展示类型 -->
                            <li>
                                <div class='list_title'> <span class="cRed">*</span> 展示类型 :</div> 
                                <div class="list_con">
                                    <Select class="select "  v-model="model9">
                                        <Option  v-for="item in type2" :value="item.code" :key="item.code">{{ item.name }}</Option>
                                    </Select>
                                </div>                                            
                            </li> 
                            <!-- 跳转ID-->
                            <li>
                                <div class='list_title'>  跳转ID :</div> 
                                <div class="list_con">
                                    <Input   v-model="model4"   type='text' class="ipt"  placeholder="请输入跳转ID"    />
                                </div>                                            
                            </li>                
                            <!-- 跳转路径 -->
                            <li>
                                <div class='list_title'>  跳转路径 :</div> 
                                <div class="list_con">
                                    <Input  v-model="model7"    type='text' class="ipt"  placeholder="请输入跳转路径"    />
                                </div>                                            
                            </li>    

                                                              
                            <!-- 图片状态 -->
                            <li>
                                <div class='list_title'>  图片状态 :</div> 
                                <div class="list_con">
                                    <i-switch class='mSwitch' v-model="model8" true-value="0" false-value="1" @on-change="change_btn" />
                                </div>                                            
                            </li>                                          

                        
                        
                        </ul>
                    </Modal>
                    
                </div>

            </div>

       </div>
       
  </div>
</template>

<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { format } from 'path';
    import CryptoJS from 'crypto-js';
    import cropper from '../../child_vue/vue_cropper.vue';

    export default {
        name:'guanliyuan',
        data () {
            return {
                route: null,
                token:'',
               

                columns1:[],
                  
                data1:[],
                

                checkGuid2:'',
           
                val: -1,
                                        
                             
                modal1: false, // 添加弹窗
                modal2: false,   //管理员添加

                model1: '0',    //跳转类型
                model2: null,   //轮播标题
                model3: null,   //轮播描述 
                model4: null,   //跳转ID
                model5: null,   //图片 
                model6: null,   //排序 
                model7: null,   //跳转路径  
                model8: '0',      //图片状态  
                model9: '0',     //展示类型
                
               
                guid: null,

                delM: false,



                type: [   //类型组
                    {code:'0',name:'网页跳转'},
                    {code:'1',name:'资讯类别跳转'},
                    {code:'2',name:'资讯详情跳转'},
                    {code:'3',name:'话题跳转'},
                    {code:'4',name:'帖子详情页跳转'},
                    {code:'5',name:'用户界面'},
                    {code:'6',name:'展示'},
                    {code:'7',name:'跳转商品'}
                    
                ],  
                type2: [   //展示类型
                    {code:'0',name:'动态'},
                    {code:'1',name:'商城'},
                ],  

               
                image_back: null,      //上传图片后返回值

                ed_img: null,           //编辑中查看的图片


                            
                cropper_data:{
                    btn_name: '上传图片',
                    outputType: 'jpeg',  //生成图片格式
                    type:'1',            //图片分组
                    vCropper:'5',        //插件分组
                    enlarge:"4",         //倍数
                    autoCropWidth:"250",
                    autoCropHeight:"100"
                },  
                cropper_data1:{
                    btn_name: '上传图片',
                    outputType: 'jpeg',  //生成图片格式
                    type:'1',            //图片分组
                    vCropper:'6',        //插件分组
                    enlarge:"4",         //倍数
                    autoCropWidth:"250",
                    autoCropHeight:"100"
                },  

                child_val: null,  //child 反馈
            }
        },
     
        watch:{
           
          
        },
        components: {cropper},
        props: ["uploadType"],
        computed: {
            is_change_layout(){
               return this.$store.getters.is_change_layout
            },
            is_change_vCropper(){
               return this.$store.getters.is_change_vCropper
            },
         
            
        },
        
        methods: {
           load(){
                var that = this;

                that.$myAjax.get('admin/service/admin/trend/roll').then( res => {
                   
                    that.data1 = res.data.data;
                    for(let i = 0;i<that.data1.length;i++){

                        if(that.data1[i].display == 0){
                            that.data1[i].display2 = true;
                        }else{
                            that.data1[i].display2 = false;
                        }

                        switch(that.data1[i].jumpType){
                            case  0:
                                that.data1[i].jumpType2 = "网页跳转";
                                break;
                            case  1:
                                that.data1[i].jumpType2 = "资讯类别跳转";
                                break;
                            case  2:
                                that.data1[i].jumpType2 = "资讯详情跳转";
                                break;
                            case  3:
                                that.data1[i].jumpType2 = "话题跳转";
                                break;
                            case  4:
                                that.data1[i].jumpType2 = "帖子详情页跳转";
                                break;
                            case  5:
                                that.data1[i].jumpType2 = "用户界面";
                                break;
                            case  6:
                                that.data1[i].jumpType2 = "展示";
                                break;
                            default:
                                that.data1[i].jumpType2 = "未知"
                        }
                        
                    }

                    that.columns1 = [
                        {title:"排序",key:"sort",align:"center",width:80},
                        {title:"标题",key:"title",align:"center",minWidth: 100},
                        {title:"图片",slot:"image",align:"center",width:150},
                        {title:"图片状态",key:"display",align:"center",width:110,
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.display == "0"
                                      },
                                      on: {
                                          'on-change': (value) => {
                                              let val;
                                              if(value){
                                                val = 0
                                              }else{
                                                val = 1
                                              }

                                              that.$myAjax.put('admin/service/admin/trend/roll?route=/layout/circle/banner/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "display": val
                                                  }
                                              ).then(res => {
                                                  that.load();
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }
                        },
                        {title:"轮播ID",key:"jumpGuid",align:"center",minWidth: 110},
                        {title:"轮播描述",key:"content",align:"center",minWidth:120},
                        {title:"跳转类型",key:"jumpType2",align:"center",width: 110},
                        {title:"展示类型",slot:"type",align:"center",width: 110},
                        {title:"跳转路径",key:"url",align:"center",minWidth:150},
                        {title:"创建时间",key:"createTime",align:"center",minWidth: 125},
                        {title:"操作",slot:"btn",align:"center",width:130,fixed: 'right'},
                    ]

                    that.$data_null.editor(that.data1);
                })
                
                

             
           },

          
           // 编辑
            editorFun(res){
                let that = this;
                that.modal1 = true;
    
                that.guid = res.guid;
                

                that.model1 = JSON.stringify(res.jumpType);
                that.model2 = res.title;
                that.model3 = res.content;
                that.model4 = res.jumpGuid;
                that.model5 = null;
                that.model6 = res.sort;
                that.model7 = res.url;
                that.model8 = JSON.stringify(res.display);
                that.model9 = JSON.stringify(res.type);
               


                that.ed_img = res.image;

                that.$canBtn( that.route).then( function(res_c){})
            },
           

            //    编辑弹窗
            ok1() {
                var that = this;

                let data = {
                        guid: that.guid,
                        jumpType: that.model1,
                        title: that.model2,
                        content: that.model3,
                        jumpGuid: that.model4,
                        image: null,
                        sort: that.model6,
                        url: that.model7,
                        display: that.model8,
                        type: that.model9
                }
                this.$data_null.del(data)
                console.log(data)

                if(!that.child_val){
                    that.$myAjax.put( 'admin/service/admin/trend/roll?route='+that.route,
                        data   
                    ).then(res => {                        
                        if(res.data.code != 0){
                            that.load();
                            that.cancel1();
                        };  
                    })
                }else{
                    that.$upload(
                        that.child_val
                    ).then(res => { 
                        that.ed_img = res.data.data.path;
                        data.image = res.data.data.name;
                        that.$myAjax.put( 'admin/service/admin/trend/roll?route='+that.route,
                            data
                        ).then(res => {
                            
                            if(res.data.code != 0){
                                that.load();
                                that.cancel1();
                                
                            };
                            
                        })
                    })
                    
                }
            },
            cancel1() {
                this.modal1 = false;
               
               
            },
           
            // 删除用户组
            delFun(res){
                let that = this;
                
                that.guid = res.guid;
                that.delM = true;
                that.$canBtn( that.route).then( function(res_c){})
            },
            delOk(){
                let that = this;
                that.$myAjax.delete(
                    'admin/service/admin/trend/roll?guid='+that.guid+'&route='+that.route,
                    {
                        guid: that.guid
                    }
                ).then(res => {
                
                    that.load();
                })
                
            },
            
            
            // 顶部添加
            
            addFun(route){
                let that = this;
                that.modal2 = true;

                that.model1 = '6';
                that.model2 = null;
                that.model3 = null;
                that.model4 = null;
                that.model5 = null;
                that.model6 = null;
                that.model7 = null;
                that.model8 = '0';
                that.model9 = '0';

                that.$canBtn( that.route).then( function(res_c){});
              
            },
            ok_add(){
                let that = this;
                
                
                // that.$myAjax.post(
                
                //     'admin/service/admin/trend/roll?route='+that.route,
                //     {
                //         'jumpType': JSON.parse(that.model1),
                //         'title': that.model2,
                //         'content': that.model3,
                //         'jumpGuid': that.model4,
                //         'image': that.model5,                     
                                        
                //         'sort': that.model6,                      
                //         'url': that.model7,
                //         'display': that.model8
                //     }
                    
                // ).then(res => {
                //     that.$alert.info(res);
                //     if(res.data.code != 0){
                //         that.load();
                //         that.cancel_add();
                //     }      
                // }) 
                let data = {
                    'jumpType': JSON.parse(that.model1),
                    'title': that.model2,
                    'content': that.model3,
                    'jumpGuid': that.model4,
                    'image': null,                     
                                    
                    'sort': that.model6,                      
                    'url': that.model7,
                    'display': that.model8,
                    'type': that.model9
                }

                if(!that.child_val){
                    that.$myAjax.post('admin/service/admin/trend/roll?route='+that.route,
                        data
                    ).then(res => {
                    
                        if(res.data.code != 0){
                            that.load();
                            that.cancel_add();
                        }
                        
                    })
                }else{
                    that.$upload(
                        that.child_val
                    ).then(res => { 
                        data.image = res.data.data.name;
                        that.$myAjax.post('admin/service/admin/trend/roll?route='+that.route,
                            data
                        ).then(res => {
                            
                            if(res.data.code != 0){
                                that.load();
                                that.cancel_add();
                            }
                            
                        })
                    }) 
                }
            },
            cancel_add(){ 
                this.modal2 = false;
            },
            // 提交按钮
            change(){
            
            },
           change_btn(bool){
               this.model8 = bool;
               
           },
            // 剪切上传
            childFun2(data){
                let that = this;
                that.child_val = data.pic_url;   
               
            }
        },
        mounted: function(){
           var that = this;
           that.token = that.$store.state.token;

           that.vCropper = that.$store.state.vCropper;
          
            that.load();
          
        }
    }
</script>
<style scoped>
    
    .list_ul li{
        padding: 5px 10px!important;
    }
     /* 表格下方无翻页按钮时 */
    .ivu-table-wrapper{
        margin-bottom: 50px;
    }

  .dis_none{
    display: none;
  }

    /* 弹窗 */
    .list_ul{
        width:100%;
        height: auto;
    }
    .list_ul li{
        width: 100%;
        height: auto;
        overflow: hidden;
        padding: 5px 0;
    }
    .list_ul .list_title{
        float: left;
        width: 26%;
        text-align: right;
        padding-right: 10px;
        line-height: 32px;
        font-size: 14px;
    }
    .list_ul .list_con{
        float: left;
        width: 60%;
    }
    
    .img_c{
        position: relative;
        display: inline-block;
        width: 100px;
        height: 40px;
        border-radius: 3px;
        overflow: hidden;
        white-space:nowrap;
        text-align: center;
        vertical-align: middle;
    }
    .img_c img{
        position: absolute;
        top: 50%;left:50%;
        transform: translate(-50%,-50%);

        height: 40px;
    }
    
</style>



